enum TmdbImageSize {
  SMALL = 'w300',
  MEDIUM = 'w780',
  LARGE = 'w1280',
  ORIGINAL = 'original',
}

export default TmdbImageSize;
